import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

/**
 * QR dibujado en el navegador (1.8, activar los dos pasos): el `otpauth://` no sale nunca del dispositivo. Se pinta en SVG
 * con un margen de 4 módulos (el mínimo que piden los lectores) y de nivel M, y lleva texto para quien no lo ve.
 */
export function CodigoQr({ valor, etiqueta, tamano = 176 }: { valor: string; etiqueta: string; tamano?: number }) {
    const dibujo = useMemo(() => {
        const qr = qrcode(0, 'M');
        qr.addData(valor);
        qr.make();
        const n = qr.getModuleCount();
        const margen = 4;
        let d = '';
        for (let f = 0; f < n; f += 1) {
            for (let c = 0; c < n; c += 1) {
                if (qr.isDark(f, c)) {
                    d += `M${String(c + margen)} ${String(f + margen)}h1v1h-1z`;
                }
            }
        }
        return { lado: n + margen * 2, d };
    }, [valor]);
    return (
        <svg
            role="img"
            aria-label={etiqueta}
            width={tamano}
            height={tamano}
            viewBox={`0 0 ${String(dibujo.lado)} ${String(dibujo.lado)}`}
            shapeRendering="crispEdges"
            style={{ background: '#fff', borderRadius: 12, display: 'block' }}
        >
            <path d={dibujo.d} fill="#111" />
        </svg>
    );
}
